import { render } from "./War.vue?vue&type=template&id=43a6b8eb"
import script from "./War.vue?vue&type=script&lang=js"
export * from "./War.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__